import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autosave-popover',
  templateUrl: './autosave-popover.component.html',
  styleUrls: ['./autosave-popover.component.scss'],
})
export class AutosavePopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
